!<!--  -->
<template>
<div class=''>
  <div class="countryList">
      <div class="country">
          <span>行政区划：</span>
      </div>
      <div class="country">
          <span @click="setAllCheck()" :class="{ countryon: all }">全部</span>
      </div>
      <div class="country" v-for="(item,index) in towns" :key="index">
          <span  @click="setListCheck(index, item.adcd)" :class="{ countryon: item.check }">{{item.adnm}}</span>
      </div>
  </div>
</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import monitorTypes from '@/store/types/monitor'
export default {
// import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      all: true,
      towns: [],
      checkarr: [],
      isTown: true,
      searchName: '',
      pageIndex: '1',
      pageSize: '100',
      aDDVCD: '330324'
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // settownadcd () {
    //   this.$emit('gertown', this.aDDVCD)
    // },
    towndata () {
      let arr = []
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.total
        this.towns = data.results
        this.towns.forEach(item => {
          let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
          obj.adcd = item.adcd
          if (item.adnm.includes('镇') || item.adnm.includes('乡')) {
            let wordarr = item.adnm
            obj.adnm = wordarr.slice(0, wordarr.length - 1)
          } else if (item.adnm.includes('街道')) {
            let wordarr = item.adnm
            obj.adnm = wordarr.replace('街道', '')
          } else {
            let wordarr = item.adnm
            obj.adnm = wordarr
          }

          obj.id = item.id
          arr.push(obj)
        })
        this.towns = arr
      })
    },
    setListCheck (idx, adcd) {
      this.all = false
      this.aDDVCD = ''
      let check = this.towns[idx].check
      this.towns.forEach((item, index) => {
        if (item.adcd === adcd) {
          this.towns[idx].check = !check
        } else {
          this.towns[index].check = false
        }
      })
      if (adcd) {
        this.aDDVCD = adcd.substring(0, 9)
      }
      let checknum = this.thecheck()
      if (checknum === 0) {
        this.setAllCheck()
      } else {
        this.$emit('townadcd', this.aDDVCD)
      }
    },
    setAllCheck () {
      this.all = true
      this.aDDVCD = ''
      this.towns.forEach((item) => {
        item.check = false
      })
      this.$emit('townadcd', this.aDDVCD)
    },
    thecheck () {
      let num = 0
      this.towns.forEach((item) => {
        if (item.check) {
          num++
        }
      })
      return num
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.towndata()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.countryList{
    height: 62px;
    background-color: #ffffff;
    border-radius: 5px;
    color: #444444;
    font-size: 15px;
    .country{
      float: left;
      font-family: Microsoft YaHei UI;
      font-size: 15px;
      text-align: center;
      margin-top: 20px;
      margin-left: 0.15%;
      cursor: pointer;
      .countryon, .categoryon{
        border-radius: 15px;
        background-color: #fda72c;
        color: #ffffff
      }
      span{
        padding: 4px 12px;
      }
    }
  }
</style>
